const Mediator = require('mediator-js');
const mediator = new Mediator();

module.exports = mediator;


// WEBPACK FOOTER //
// ./js/mediator.js